import { render } from "./About.vue?vue&type=template&id=8d57b2e6&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=8d57b2e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1372789139/src/portfolio-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d57b2e6"]])

export default __exports__